/* 
0. intention correction	
1. algolia_analytics.js	
2. algolia_translations.js		
3. algolia_helpers.js
4. algolia_autocomplete.js
5. algolia_facets.js
6. algolia_sort_orders.js
7. algolia_instant_search.js
*/
/* #0. */
function intentionCorrection(queryInp){
    var reQueryString = '';
    if(typeof queryInp !== undefined){
        var reQueryString = '';
        var reQueryPush = [];
        var reQueryArr = queryInp.split(' ');
        reQueryArr.forEach(function(reQueryPart) {
            reQueryPush.push(reQueryPart);
            /// FIND INTENTION ///
            var reQueryFirst = reQueryPart.charAt(0);
            var reQueryLng = reQueryPart.length;
            // numeric search 3 or more numbers //
            if(!isNaN(reQueryFirst) && reQueryLng > 2){
                reQueryPartClean = reQueryPart.replace('-', '/');
                reQueryPartSkuMain = reQueryPartClean;
                reQueryPartSkuColor = '';
                if(reQueryPartClean.indexOf('/') > -1){
                    reQueryPartSkuArr = reQueryPartClean.split('/');
                    reQueryPartSkuMain = reQueryPartSkuArr[0];
                    reQueryPartSkuColor = '/' + reQueryPartSkuArr[1];
                }
                reQueryPartSkuMainLng = reQueryPartSkuMain.length;
                // main article lng prefixer //
                /*if(reQueryPartSkuMainLng == 3){
                    //console.log('INTENTION CORRECT 1');
                    reQueryPush.push('00' + reQueryPartSkuMain + reQueryPartSkuColor);
                    reQueryPush.push('0' + reQueryPartSkuMain + reQueryPartSkuColor);  
                } else if(reQueryPartSkuMainLng == 4){
                    //console.log('INTENTION CORRECT 2');
                    //reQueryPush.push( reQueryPartSkuColor + ' OR 0' + reQueryPartSkuMain);
                    reQueryPush.push('OR 0' + reQueryPartSkuMain + reQueryPartSkuColor);  
                }*/
            }
        });
        reQueryString = reQueryPush.join(' ');
    }
    return reQueryString;
}
/* #1. */
(function (algolia) {
  'use strict';

  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;
  
    var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.0.3";
    !function(e,a,t,n,s,i,c){
        e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
            (e[s].queue=e[s].queue||[]).push(arguments)
        },i=a.createElement(t),c=a.getElementsByTagName(t)[0], i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
    }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");
  
    window.aa('init', {
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key
    })
}(algoliaShopify));

/* #2. */
(function (algolia) {
  'use strict';
  
    var algolocal = {
      en: {
        yes: "Yes",
		no: "No",
        from: "From",
        weight: "Weight",
        composition: "Composition",
        certificates: "Certificates",
        swatch: "Color",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scroll to results",
        showFilter: "Show filters",
        hideFilter: "Apply filters",
        selectedFilter: "Active filters",
        clearAll: "Clear all",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        inSec: "in",
        outOf: "out of",
        sort_by: "Sort by",
        sort_labels: {
          default: "Art.Nr. (all colors)",
          title_asc: "Art.Nr. (Grouped)",
          published_at_desc: "Color",
          recently_ordered_count_desc: "Most popular",
        },
      },
      de: {
        yes: "Ja",
		no: "Nein",
        from: "Preis ab",
        weight: "Gewicht",
        composition: "Zusammensetzung",
        certificates: "Zertifikate",
        swatch: "Farbe",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scrollen Sie zu den Ergebnissen",
        showFilter: "Filter anzeigen",
        hideFilter: "Filter anwenden",
        selectedFilter: "Aktive Filter",
        clearAll: "Löschen",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        inSec: "in",
        outOf: "von",
        sort_by: "Sortiere nach",
        sort_labels: {
          default: "Art.-Nr. (Alle Farben)",
          title_asc: "Art.-Nr. (Gruppiert)",
          published_at_desc: "Farbe",
          recently_ordered_count_desc: "Am beliebtesten",
        },
      },
      nl: {
        yes: "Ja",
		no: "Nee",
        from: "Vanaf",
        weight: "Gewicht",
        composition: "Samenstelling",
        certificates: "Certificaten",
        swatch: "Kleur",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "gevonden",
        oneResultFound: "1 gevonden",
        noResultFound: "Geen resultaten gevonden.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scroll naar resultaten",
        showFilter: "Filters tonen",
        hideFilter: "Filters toepassen",
        selectedFilter: "Actieve filters",
        clearAll: "Wissen",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        inSec: "in",
        outOf: "van",
        sort_by: "Sorteer op",
        sort_labels: {
          default: "Art.Nr. (alle kleuren)",
          title_asc: "Art.Nr. (gegroepeerd)",
          published_at_desc: "Kleur",
          recently_ordered_count_desc: "Meest populair",
        },
      },
      fr: {
        yes: "Oui",
		no: "Non",
        from: "A partir",
        weight: "Poids",
        composition: "Composition",
        certificates: "Certificats",
        swatch: "Couleur",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sélectionner",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Aller aux résultats",
        showFilter: "Afficher les filtres",
        hideFilter: "Appliquer des filtres",
        selectedFilter: "Filtres actifs",
        clearAll: "Effacer",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        inSec: "en",
        outOf: "sur",
        sort_by: "Sélectionner",
        sort_labels: {
          default: "N° Art. (Toutes les couleurs)",
          title_asc: "N° Art. (Regroupé)",
          published_at_desc: "Couleur",
          recently_ordered_count_desc: "Les plus populaires",
        },
      },
      es: {
        yes: "Sí",
		no: "No",
        from: "Desde",
        weight: "Peso",
        composition: "Composición",
        certificates: "Certificados",
        swatch: "Color",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Desplazarse a resultados",
        showFilter: "Mostrar filtros",
        hideFilter: "Aplicar filtros",
        selectedFilter: "Filtros activos",
        clearAll: "Claros",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        inSec: "en",
        outOf: "de",
        sort_by: "Ordenar por",
        sort_labels: {
          default: "Art.Núm. (Todos los colores)",
          title_asc: "Art.Núm (Agrupado)",
          published_at_desc: "Color",
          recently_ordered_count_desc: "Más popular",
        },
      }
    }
  
  if(!algolia.language || !(algolia.language in algolocal)){
      algolia.language = 'en';
  }
  algolia.translations = algolocal[algolia.language];
  

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return 'No result for query ' + render(text) + '';
    },
    in: function (text, render) {
      return algolia.translations.inSec + ' ' + render(text) + 's';
    },

    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return 'Try ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
    },
    outOf: function (text, render) {
      return '' + render(text) + ' '+ algolia.translations.outOf;
    },

    by: function (text, render) {
      return 'by ' + render(text) + '';
    }
  };

}(algoliaShopify));

/* #3. */
/* See https://community.algolia.com/shopify/hogan-helpers.html */

(function (algolia) {
    'use strict';
    var _ = algolia._;
    var formatPrice = function formatPrice(value) {
        return algolia.formatMoney(+value * 100);
    };

    function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
        var comparing = +compare_at_price && +compare_at_price > +price,
            discount_ratio = 1.0 - price_ratio,
            res = '<b>' + formatPrice(price) + '</b>';
        if (comparing) {
            res += ' <span class="ais-hit--price-striked"><span>' + formatPrice(compare_at_price) + '</span></span> ';
            res += ' <span class="ais-hit--price-discount" style="font-weight: ' + (Math.floor(discount_ratio * 10) * 100) + ';">-' + Math.floor(discount_ratio * 100) + '%</span>';
        }
        return res;
    }

    var escapeHtml = function escapeHtml(unsafe) {
        return (unsafe || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    algolia.helpers = {
        collectionName: function collectionName(text, render){
          var aaCollName = text;
          if(typeof this.handle !== 'undefined'){
            // prep lookup handle //
            var aaCollHandle = '/collections/' + this.handle;
            if(algolia.language !== 'en'){
              aaCollHandle = '/' + algolia.language + aaCollHandle;
            }
            // find collection in main-menu //
            var $aaCollMatchElem = $('.main-menu a[href="'+aaCollHandle+'"]').last();
            if($aaCollMatchElem){
                var aaCollMatchTxt = $aaCollMatchElem.text();
                if(aaCollMatchTxt != ''){
                    // find closest head collection //
                    var aaCollClosestHd = $aaCollMatchElem.closest('.main-submenu-col').find('a.submenu-col-title').text();
                    if(aaCollClosestHd != ''){
                        aaCollMatchTxt = '<em>'+aaCollClosestHd + ' <i class="fa fa-angle-right" aria-hidden="true"></i></em> ' + aaCollMatchTxt;
                    }
                    aaCollName = aaCollMatchTxt; 
                }
            }
          }
          return aaCollName;
        },
        noSearchResult: function noSearchResult(){
            //$('.main-collection-wrapper .collection-page').addClass('empty-search-page');
        },
        namedLang: function namedLang(namedTag){
			var nmdAl = algolia.language;
          	var nmdAlPref = nmdAl+'__'+namedTag;
          	return '[[ named_tags.' + nmdAlPref + ' ]]';
        },
        formatNumber: function formatNumber(text, render) {
            return Number(render(text)).toLocaleString();
        },
      	formatFacetCount: function formatFacetCount(text, render) {
          	return parseInt(render(text));
        },
        formattedPrice: function formattedPrice(text, render) {
            return formatPrice(render(text));
        },
        formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(text, render) {
            return formatPrice(render(text)).replace(/\.\d+$/, '');
        },
      	prepCompo: function prepCompo(text, render) {
          var ai_comprep = render(text).replace('/', ' / ');
          return ai_comprep;
        },
      	calcWeight: function calcWeight(text, render) {
          	
        },
        wshlst: function wshlst(text, render) {
          var wsh_sku = this.sku.replace('/','-');
          var wsh_html = '<span class="wshlst" data-sku="' + wsh_sku  + '" data-product="' + this.id + '" data-variant="' + this.objectID + '"></span>';
          return wsh_html;
        },
      	productCert: function productCert() { 
          var certs_html = '';
          var certs_1_html = '';
          var certs_2_html = '';
          var certs_3_html = '';
          if(this.product_type && this.product_type == 'Special'){
            certs_3_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/t/83/assets/logo-special_design.svg?v=96213850449557371851744273103" alt="Special Design" class="aa-svgimg">';
          }
          if(this.named_tags.Certificates){
            var certs_check = this.named_tags.Certificates;
            if(certs_check.indexOf("Oeko-Tex Kl2") > -1){
              certs_3_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/files/cert_oekotex-C2_130x68.png?v=12748277863924001375&c=1">';
            } else if(certs_check.indexOf("Oeko-Tex Kl1") > -1){
              certs_3_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/files/cert_oekotex-C1_130x68.png?v=7908730218682261277&c=1">';
            } else if(certs_check.indexOf("Oeko-Tex Kl1 - Organic") > -1){
              certs_3_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/files/cert_oekotex-C1-O_130x68.png?v=10488931655493019050&c=1">';
            }
            if(certs_check.indexOf("Mulesing Free") > -1){
              certs_1_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/files/cert_mulesing_free_63x63.png?v=1009117029456429454" alt="Mulesing Free">';
            }
            if(certs_check.indexOf("Recycled") > -1){
              certs_1_html += '<img loading="lazy" src="//www.hemmersitex.de/cdn/shop/files/cert_recycled_63x63.png?v=12103074361863491514" alt="Recyled">';
            }
          }
          certs_html = '<span class="cert-labels">';
              certs_html += '<span class="cert-label">'+certs_1_html+'</span>';
              certs_html += '<span class="cert-label">'+certs_2_html+'</span>';
              certs_html += '<span class="cert-label">'+certs_3_html+'</span>';
          certs_html += '</span>';
          return certs_html;
      	},
      	productLabels: function productLabels() {
          var label_nophoto = '';
          var label_green_html = '';
          var label_red_html = '';
          var label_black_html = '';
          if(typeof cust_globagent_code !== 'undefined'){
              if(cust_globagent_code === 'a4' || cust_globagent_code === 'a3'){
                if(this.collections){
                  var promoCheckColl = this.collections.toString(); 
                }
              }
          }
          if(this.named_tags.Collection){
			var label_check_coll = this.named_tags.Collection;
            if(label_check_coll.indexOf("Special offers") > -1){
              	label_red_html = '<span class="red-label">SALE</span>';
            }
		  }
          if(this.named_tags.Labels){
            var label_check_stat = this.named_tags.Labels;
            if(label_check_stat == 'Almost sold out'){
              	label_black_html = '<span class="black-label">ALMOST SOLD OUT</span>';
            }
          }
          if(this.named_tags.Status){
            var label_check_stat = this.named_tags.Status;
            if(label_check_stat == '9'){
              	label_black_html = '<span class="pink-label">LAST PIECE</span>';
            }
          }
          if(this.named_tags.Collection){
			var label_check_coll = this.named_tags.Collection;
			if(label_check_coll.indexOf("Limited edition") > -1){
				label_green_html = '<span class="green-label">LIMITED<br />EDITION</span>';
			}
		  }
          if(this.named_tags.Productphoto && this.named_tags.Productphoto == 'design'){
            label_nophoto = '<span class="label-nophoto"><img src="//www.hemmersitex.de/cdn/shop/files/label-nophoto_115x.png?v=14647655377173717599" width="115" height="30" loading="lazy" ></span>';
          }
		  return label_nophoto + label_green_html + label_red_html + label_black_html;
        },
        autocompletePrice: function autocompletePrice(text, render) {
            if (this._distinct) {
                var min = this.variants_min_price;
                var max = this.variants_max_price;
                if (min !== max) {
                    return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
                }
            }
            return formattedPriceWithComparison(this.price, null);
        },
        instantsearchPrice: function instantsearchPrice(text, render) {
            if (this._distinct) {
                var min = this.variants_min_price;
                var max = this.variants_max_price;
                if (min !== max) {
                    return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
                }
            }
            return formattedPriceWithComparison(this.price, this.compare_at_price, this.price_ratio);
        },
        instantsearchLink: function instantsearchLink(text) {
            var collectionUrl = '';
            if (text !== '') {
                collectionUrl = text;
             } else {
              if(algolia.language !== 'en'){
              	collectionUrl = '/' + algolia.language;
              }
            }
            var addVariantId = !this._distinct && this.objectID !== this.id;
            return collectionUrl + '/products/' + this.handle + (addVariantId ? ('?variant=' + this.objectID) : '');
        },
        fullTitle: function fullTitle() {
            var res = this.title;
            if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
                res += ' (' + this.variant_title + ')';
            }
            return escapeHtml(res);
        },
        subTitle: function subTitle(text) {
            var title = "";
          	var raw_subtitle = "";
            if ( this.meta.subtitle && this.meta.subtitle.Subtitle ) {
              	title = this.meta.subtitle.Subtitle;
              	var titlefluf = title.replace(/ /g, '').substr(-4, 4);
                if(titlefluf == 'with'){
					title = title.replace('with', '');
                }
            }

            return title;
        },
        description: function description(text) {
            var title = this.title;
            if ( this.body_html_safe ) {
                title = this.body_html_safe;
            }
            return title;
        },
      	isSpecial: function isSpecial() {
          var specrt='';
          if(this.product_type && this.product_type == 'Special'){
            specrt = '<span class="aa-isspecial">Special Design</span>';
          }
          return specrt;
        },
        fullHTMLTitle: function fullHTMLTitle() {
            var res = this._highlightResult.sku.value;
            if (this._indx_used == 'hemm_products_title_asc'){
              if(typeof this.named_tags.MainProduct !== 'undefined'){
            	var res = this.named_tags.MainProduct;
              }
          	}
            return res;
        },
        fastButtons: function fastButtons(text,render) {
          	var fast_buttons = '';
          	if(this.named_tags.xvardata){
              var fast_data = this.named_tags.xvardata;
              var fast_data_Arr = fast_data.split('|').reverse();
              var fast_data_inCart = text;
              var fast_data_pref = '/products/';
              if(algolia.language !== 'en'){
              	fast_data_pref = '/' + algolia.language + fast_data_pref;
              }
              var fast_data_handle = fast_data_pref + this.handle;
              var fast_data_handle_suff = '';
              var fast_data_artnr = this.sku;
              $.each(fast_data_Arr, function (index, fast_data_Part) {
                if(fast_data_Part != ''){
                  	var fast_button_Arr = fast_data_Part.split('#');
                  	var fast_button_Chk = fast_button_Arr.length;
                    if(fast_button_Chk == 3){
                      var fast_button_type = fast_button_Arr[0].toLowerCase();
                      var fast_button_lng = fast_button_Arr[1];
                      var fast_button_ava = fast_button_Arr[2];
                      if(fast_button_ava > 0){
                        // Build button //
                        var fast_button_html = '';
                        var fast_button_desc = fast_data_inCart;
                        var fast_button_class = '';
                        var fast_button_img = '';
                        if(fast_button_lng > 1){
                          fast_button_desc = fast_button_lng + 'm';
                          fast_button_class = ' desc_down';
                        }
                        if(fast_button_type.indexOf('roll') > -1){
                          fast_button_img = '<img src="//www.hemmersitex.de/cdn/shop/t/83/assets/icon-product-roll.svg?v=144448790106455439961744273092" class="action-button-icon-type">';
                        } else if(fast_button_type.indexOf('fold') > -1){
                          fast_button_img = '<img src="//www.hemmersitex.de/cdn/shop/t/83/assets/icon-product-fold.svg?v=147834511533833159861744273090" class="action-button-icon-type">';
                        }
                        fast_data_handle_suff = '/' + encodeURIComponent(fast_button_type);  
                        fast_button_html += '<a href="#" class="fastadd-ais-button ais-hit--button action--button action---plus' + fast_button_class + '" title="' + fast_button_desc + ' ' + fast_data_inCart + '" tabindex="0" data-fastais-handle="' + fast_data_handle + fast_data_handle_suff + '" data-fastais-artnr="' + fast_data_artnr + '" data-fastais-var="' + fast_button_type + '">';
                        	fast_button_html += '<span class="action-button-icon-plus">+</span>';
                            fast_button_html += fast_button_img;
                        	fast_button_html += '<span class="action-button-desc">' + fast_button_desc + '</span>';
                    	fast_button_html += '</a>';
                        // reset small piece //
                        if(fast_button_type.indexOf('small') > -1){
                          fast_button_html = '';
                        }
                        fast_buttons += fast_button_html;
                      }
                    }
                }
              });
            }
            if(this.named_tags.Status){
              var fast_status = this.named_tags.Status;
              if(fast_buttons == '' || fast_status == '9'){
                fast_buttons = '<a href="#0" class="fastmore-ais-button action--button">info</a>';
              }
            }
          	return fast_buttons;
        },
        customerPrice: function (text, render) {   
          if (this.meta.group_prices && this.meta.group_prices.Prices) {
            /* # set GENERAL vars # */   
            let ALprod_xx = 99900;
            let ALprod_ag = 0;
            let ALprod_lpc = '';
            let ALprod_spc = '';
            let ALshop_date = parseInt(main_glob_date);
            /* # set CUSTOMER vars # */
            //let ALdataArr = text.split('===');
            let ALcust_offers = cust_glob_offers;
            let ALcust_pg = cust_glob_pg;
            let ALcust_ag = cust_glob_ag;
            let ALcust_campagnes = cust_glob_cmpg;
            
            /* # set PRODUCT vars # */
            let ALprod_sku = this.sku;
            let ALprod_main = ALprod_sku.split('.')[0]; 
            let ALprod_sku_lookup = ALprod_sku + ':'
            let ALprod_main_lookup = ALprod_main + ':'
            let ALprod_pric_str = this.meta.group_prices.Prices;
            let ALprod_pric_arr = ALprod_pric_str.split('|');
            let ALprod_unit = 'm';
            
            /* # 0. CALCULATION START */
            $.each(ALprod_pric_arr, function (index, ALprod_pric_part){
              let ALpart_arr = ALprod_pric_part.split(':');
              let ALpart_key = ALpart_arr[0].trim().toUpperCase();
              if(ALpart_key == 'XX'){
                ALprod_xx = ALpart_arr[1];
              } else if(ALpart_key == 'AG'){
                //ALprod_ag = 'AG' + ALpart_arr[1];
                ALprod_ag = ALpart_arr[1];
              } else if(ALpart_key == 'LPC'){
                ALprod_lpc = ALpart_arr[1];
              } else if(ALpart_key == 'SPC'){
                ALprod_spc = ALpart_arr[1];
              }
            });
            let ALorig_price = ALprod_xx;
            let ALsell_price = ALprod_xx;
            let ALcalc_quit = 0;
            let ALcalc_meth = 'listprice ';
            /* # 1. LPC */
            if(ALprod_lpc != '' && ALcust_campagnes != '' && ALcust_campagnes != '(NONE)'){
              let ALcust_campagnes_arr = ALcust_campagnes.split('|');
              let ALprod_lpc_arr = ALprod_lpc.split(';');
              let ALprod_lpc_name = ALprod_lpc_arr[0];
              let ALprod_lpc_start = parseInt(ALprod_lpc_arr[2]);
              let ALprod_lpc_end = parseInt(ALprod_lpc_arr[3]);
              // # check active
              if(ALcust_campagnes_arr.indexOf(ALprod_lpc_name) > -1){ 
                if(ALshop_date >= ALprod_lpc_start && ALshop_date <= ALprod_lpc_end){ 
                  let ALlpc_meth = ALprod_lpc_arr[4];
                  let ALlpc_disc = ALprod_lpc_arr[5];
                  let ALlpc_disc_cent = Math.round(ALlpc_disc * 100);
                  let ALlpc_use = ALprod_lpc_arr[6];
                  let ALlpc_input_price = parseInt(ALprod_xx); // listprice
                  let ALlpc_calc_price = 99900;
                  if(ALlpc_meth == 'A'){ // fixed discount
                    ALlpc_calc_price = parseInt(ALlpc_input_price) + parseInt(ALlpc_disc_cent);
                  } else if(ALlpc_meth == 'D'){ // percentage discount
                    let ALspc_calc_perc = ALlpc_input_price * ALlpc_disc;
                    ALlpc_calc_price = Math.round(ALspc_calc_perc);
                  } else if(ALlpc_meth == 'P'){ // fixed price
                    ALlpc_calc_price = ALlpc_disc_cent;
                  }
                  // max LPC
                  let ALlpc_max_disc = ALprod_lpc_arr[7];
                  if(ALlpc_max_disc != ''){
                    let ALlpc_max_disc_cent = Math.round(ALlpc_max_disc * 100);
                    let ALlpc_calc_max_check = ALlpc_input_price + ALlpc_max_disc_cent;
                    if(ALlpc_calc_max_check > ALlpc_input_price){
                      if(ALlpc_calc_price > ALlpc_calc_max_check){
                        ALlpc_calc_price = ALlpc_calc_max_check;
                      }
                    } else if(ALlpc_calc_max_check < ALlpc_input_price){
                      if(ALlpc_calc_price < ALlpc_calc_max_check){
                        ALlpc_calc_price = ALlpc_calc_max_check;
                      }
                    }
                  }
                  // # set LPC price
                  if(ALlpc_calc_price < ALorig_price){
                    ALsell_price = ALlpc_calc_price;
                  } else if(ALlpc_calc_price > ALorig_price){
                    ALorig_price = ALlpc_calc_price;
                    ALsell_price = ALlpc_calc_price;
                  }
                  ALcalc_meth = ALcalc_meth + 'lpc ';
                }
              }
            }   
            /* # 2. OFFER PRICE */
            if(ALcust_offers.indexOf(ALprod_sku_lookup) > -1 && ALcalc_quit == 0){
              let ALoffer_arr = ALcust_offers.split('|');
              $.each(ALoffer_arr, function (index, ALoffer_part){
                let ALoffer_part_arr = ALoffer_part.split(':');
                let ALoffer_prod = ALoffer_part_arr[0].trim();
                if(ALoffer_prod == ALprod_sku){
                  let ALoffer_price = ALoffer_part_arr[1];
                  ALsell_price = ALoffer_price * 1;
                  // NOW QUIT 
                  ALcalc_quit = 1;
                  ALcalc_meth = ALcalc_meth + 'offer-color ';
                }
              });
            } // else 
            if(ALcust_offers.indexOf(ALprod_main_lookup) > -1 && ALcalc_quit == 0){
              let ALoffer_arr = ALcust_offers.split('|');
              $.each(ALoffer_arr, function (index, ALoffer_part){
                let ALoffer_part_arr = ALoffer_part.split(':');
                let ALoffer_prod = ALoffer_part_arr[0].trim();
                if(ALoffer_prod == ALprod_main){
                  let ALoffer_price = ALoffer_part_arr[1];
                  ALsell_price = ALoffer_price * 1;
                  // NOW QUIT 
                  ALcalc_quit = 1;
                  ALcalc_meth =  ALcalc_meth + 'offer-main ';
                }
              });
            }
            /* # 3. PG PRICE */
            if(ALcust_pg != '' && ALcust_pg.indexOf(ALprod_sku_lookup) > -1 && ALcalc_quit == 0){
              let ALcust_pg_arr = ALcust_pg.split('|');
              $.each(ALcust_pg_arr, function (index, ALpg_part){
                let ALpg_part_arr = ALpg_part.split(':');
                let ALpg_part_prod = ALpg_part_arr[0].trim();
                if(ALpg_part_prod == ALprod_sku){
                  let ALpg_nr = ALpg_part_arr[1].trim().toUpperCase();
                  // # start itt prod
                  $.each(ALprod_pric_arr, function (prindex, ALprod_pric_part){
                    let ALpart_arr = ALprod_pric_part.split(':');
                    let ALpart_name = ALpart_arr[0].trim().toUpperCase();
                    if(ALpart_name == ALpg_nr && ALpart_arr.length > 1){
                      let ALpg_fact = ALpart_arr[1].trim();
                      if(ALpg_fact > 0){
                        let ALpg_calc = Math.round(ALorig_price * ALpg_fact);
                        ALsell_price = ALpg_calc * 1;
                        // NOW QUIT
                        ALcalc_quit = 1;
                        ALcalc_meth =  ALcalc_meth + 'pg-color ';
                      }
                    }
                  });
                }
              });
            } // else 
            if(ALcust_pg != '' && ALcust_pg.indexOf(ALprod_main_lookup) > -1 && ALcalc_quit == 0){
              let ALcust_pg_arr = ALcust_pg.split('|');
              $.each(ALcust_pg_arr, function (index, ALpg_part){
                let ALpg_part_arr = ALpg_part.split(':');
                let ALpg_part_prod = ALpg_part_arr[0].trim();
                if(ALpg_part_prod == ALprod_main){
                  let ALpg_nr = ALpg_part_arr[1].trim().toUpperCase();
                  // # start itt prod
                  $.each(ALprod_pric_arr, function (prindex, ALprod_pric_part){
                    let ALpart_arr = ALprod_pric_part.split(':');
                    let ALpart_name = ALpart_arr[0].trim().toUpperCase();
                    if(ALpart_name == ALpg_nr && ALpart_arr.length > 1){
                      let ALpg_fact = ALpart_arr[1].trim();
                      if(ALpg_fact > 0){
                        let ALpg_calc = Math.round(ALorig_price * ALpg_fact);
                        ALsell_price = ALpg_calc * 1;
                        // NOW QUIT
                        ALcalc_quit = 1;
                        ALcalc_meth =  ALcalc_meth + 'pg-main ';
                      }
                    }
                  });
                }
              });
            }
            /* # 4. AG PRICE */
            let ALprod_ag_lookup = ALprod_ag + ':';
            if(ALprod_ag != '' && ALcust_ag.indexOf(ALprod_ag_lookup) > -1 && ALcalc_quit == 0){
              let ALcust_ag_arr = ALcust_ag.split('|');
              $.each(ALcust_ag_arr, function (index, ALag_part){
                let ALag_arr = ALag_part.split(':');
                let ALag_nr = ALag_arr[0].trim().toUpperCase();
                if(ALag_nr == ALprod_ag){
                  let ALpg_nr = ALag_arr[1].trim();
                  $.each(ALprod_pric_arr, function (prindex, ALprod_pric_part){
                    let ALpart_arr = ALprod_pric_part.split(':');
                    let ALpart_name = ALpart_arr[0].trim().toUpperCase();
                    if(ALpart_name == ALpg_nr && ALpart_arr.length > 1){
                      let ALpg_fact = ALpart_arr[1].trim();
                      if(ALpg_fact > 0){
                        let ALpg_calc = Math.round(ALorig_price * ALpg_fact);
                        ALsell_price = ALpg_calc * 1;
                        // NOW QUIT
                        ALcalc_quit = 1;
                        ALcalc_meth =  ALcalc_meth + 'ag ';
                      }
                    }
                  });
                }
              });
            }
            /* # 5. SPC */
            if(ALprod_spc != '' && ALcust_campagnes != '' && ALcust_campagnes != '(NONE)'){
              let ALcust_campagnes_arr = ALcust_campagnes.split('|');
              let ALprod_spc_arr = ALprod_spc.split(';');
              let ALprod_spc_name = ALprod_spc_arr[0];
              let ALprod_spc_start = parseInt(ALprod_spc_arr[2]);
              let ALprod_spc_end = parseInt(ALprod_spc_arr[3]);
              // # check active
              if(ALcust_campagnes_arr.indexOf(ALprod_spc_name) > -1){ 
                if(ALshop_date >= ALprod_spc_start && ALshop_date <= ALprod_spc_end){ 
                  let ALspc_meth = ALprod_spc_arr[4];
                  let ALspc_disc = ALprod_spc_arr[5];
                  let ALspc_disc_cent = Math.round(ALspc_disc * 100);
                  let ALspc_use = ALprod_spc_arr[6];
                  let ALspc_input_price = parseInt(ALprod_xx); // listprice
                  let ALspc_calc_price = 99900;
                  if(ALspc_use == '2'){
                    ALspc_input_price = parseInt(ALorig_price); // origprice
                  } else if(ALspc_use == '3'){
                    ALspc_input_price = parseInt(ALsell_price); // sellprice
                  }
                  if(ALspc_meth == 'A'){ // fixed discount
                    ALspc_calc_price = parseInt(ALspc_input_price) + parseInt(ALspc_disc_cent);
                  } else if(ALspc_meth == 'D'){ // percentage discount
                    let ALspc_calc_perc = ALspc_input_price * ALspc_disc;
                    ALspc_calc_price = Math.round(ALspc_calc_perc);
                  } else if(ALspc_meth == 'P'){ // fixed price
                    ALspc_calc_price = ALspc_disc_cent;
                  }
                  // # max SPC
                  let ALspc_max_disc = ALprod_spc_arr[7];
                  if(ALspc_max_disc != ''){
                    let ALspc_max_disc_cent = Math.round(ALspc_max_disc * 100);
                    let ALspc_calc_max_check = ALspc_input_price + ALspc_max_disc_cent;
                    if(ALspc_calc_max_check > ALspc_input_price){
                      if(ALspc_calc_price > ALspc_calc_max_check){
                        ALspc_calc_price = ALspc_calc_max_check;
                      }
                    } else if(ALspc_calc_max_check < ALspc_input_price){
                      if(ALspc_calc_price < ALspc_calc_max_check){
                        ALspc_calc_price = ALspc_calc_max_check;
                      }
                    }
                  }
                  // # set SPC price
                  if(ALspc_calc_price < ALsell_price){
                    ALsell_price = ALspc_calc_price;
                    ALcalc_meth =  ALcalc_meth + 'spc ';
                  }
                }
              }
            }

            if(ALsell_price < ALorig_price){
              return '<span class="product-label-from">' + algolia.translations.from + '</span><span class="orig-meter-price">' + formatPrice( ALorig_price / 100 ).replace('.',',').replace('€','')+'</span><b data-pmeth="' + ALcalc_meth + '">' + formatPrice( ALsell_price / 100 ).replace('.',',').replace('€','')+'</b> / ' + ALprod_unit ;
            } else {
              return '<b data-pmeth="' + ALcalc_meth + '">' + formatPrice( ALsell_price / 100 ).replace('.',',').replace('€','')+'</b> / ' + ALprod_unit ;
            }
            
          }
        },
        floor: function floor(text, render) {
            return '' + Math.floor(+render(text));
        },
        ceil: function ceil(text, render) {
            return '' + Math.ceil(+render(text));
        },
        sizedImage: function sizedImage(text, render) {
            var image = this._distinct ? this.product_image : this.image;
            if (!image) {
                return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
            }
            var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
            if (size === 'original') {
                return image;
            }
            return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
        }
    };

    _.forEach(['pico', 'icon', 'thumb', 'small', 'compact', 'medium', 'large', 'grande', 'original'], function (size) {
        algolia.helpers[size + 'Image'] = (function (_size) {
            return function () {
                var image = this._distinct ? this.product_image : this.image;
                if (!image) {
                    return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
                }
                var aaImageResized = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_240x240.$2');
                if(aaImageResized.indexOf('cdn.shopify.com/s/files/1/0071/4693/0261') > -1 && window.Shopify.cdnHost){
                  aaImageResized = aaImageResized.replace('cdn.shopify.com/s/files/1/0071/4693/0261', window.Shopify.cdnHost + '/shop');
                }
                return aaImageResized;
            };
        })(size);
    });

    /* Create an Hogan lambda, which doesn't respect the mustache doc */
    algolia.hoganHelpers = _.reduce(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (res, helper, name) {
        res[name] = function () {
            return function (text) {
                var render = function (value) {
                    return Hogan.compile(value, algolia.hoganOptions).render(this);
                }.bind(this);
                return helper.call(this, text, render);
            }.bind(this);
        };
        return res;
    }, {});
}(algoliaShopify));

/* #4. */
(function (algolia) {
  if (!algolia.config.autocomplete_enabled) return;

  var _ = algolia._,
      $ = algolia.jQuery;

  var autocomplete; 
  var algolia_AC_strip = ' NOT "product_type":"Sample" AND NOT "product_type":"Special" ';
  if(!!cust_globspec_col && cust_globspec_col.length > 3){
    var algolia_ADD_adj = cust_globspec_col;
    if(algolia_ADD_adj.substring(0, 1) == 'c' ){
      algolia_AC_strip = ' "named_tags.SpecialFor":"'+algolia_ADD_adj+'" OR "product_type":"Fabric" ';
    }
  }

  function index (name) {
    return algolia.client.initIndex('' + algolia.config.index_prefix + name);
  }

  function addPositionToHits(hits, queryID, indexUsed) {
    return hits.map(function (entry, index) {
      entry._position = index + 1;
      entry._queryID = queryID;
      entry._indx_used = indexUsed;
      return entry
    })
  }

  function autocompleteSection (section) {      
    var params = autocomplete[section];
    if (params.enabled !== true) return null;

    var templates = {
      empty: function displayEmptyResultSet (props) {
        return algolia.render(params.templates.empty, Object.assign({}, props, { translations: algolia.translations }));
      },
      suggestion: function displaySuggestion (hit) {
        if(hit.handle !== "my-specials"){
          return algolia.render(params.templates.hit, Object.assign({ _distinct: params.distinct }, hit, {translations: algolia.translations}));
        }
      }
    };

    if (params.templates.footer) {
      templates.footer = function displayFooter (props, content) {
        if (content.nbHits <= params.hitsPerPage) return null;
        if (!autocomplete.showFooter) return null;
        return algolia.render(params.templates.footer, {
          query: props.query,
          nbHits: content.nbHits,
          translations: algolia.translations,
          helpers: algolia.helpers
        });
      }

    }

    return {
      name: section,
      source: function(query, callback) {
        /* NEW INTENTION CORRECTION */
        query = intentionCorrection(query);
        if(section == "collections"){
          var searchOpts = {
            clickAnalytics: true,
            hitsPerPage: params.hitsPerPage,
            highlightPreTag: '<span class="aa-highlight">',
            highlightPostTag: '</span>',
            filters: ''
          };
        } else {
          var searchOpts = {
            clickAnalytics: true,
            hitsPerPage: params.hitsPerPage,
            highlightPreTag: '<span class="aa-highlight">',
            highlightPostTag: '</span>',
            filters: algolia_AC_strip
          };
        }
        if (params.distinct) {
          searchOpts.distinct = true;
        }
        if(typeof cust_glob_did == 'string' && typeof main_globlang == 'string'){
          if(cust_glob_did == ''){
              searchOpts.userToken = main_globlang;
              searchOpts.enableABTest = false;
          } else {
              searchOpts.userToken = cust_glob_did;
              searchOpts.enableABTest = true;
          } 
        }
        index(section).search(query, searchOpts).then(function(answer) {
          var hits = addPositionToHits(answer.hits, answer.queryID, 'hemm_'+section);
          callback(hits, answer);
        });
      },
      displayKey: 'title',
      templates: templates
    }
  };

  function readjust($this) {
    var data = $this.data('aaAutocomplete');
    if (!data) return;
    var $node = data.$node;
    var $dropdown = data.dropdown.$menu;

    var width = $this.outerWidth();
    var vpWidth = document.body.clientWidth;
    var offset = $this.offset();
    var left = offset.left;
    var right = vpWidth - width - left;
    var top = offset.top;
    var height = $this.outerHeight();

    var align = left < right ? 'left' : 'right';
    var dist = Math.min(left, right);

    // For small centered inputs, take half the screen
    if (4 * dist > vpWidth) {
      align = 'left';
      dist = Math.round(vpWidth / 4);
    }

    var newWidth = vpWidth - 2 * dist;

    // For big inputs, follow the input
    if (width >= 600) {
      align = 'left';
      dist = left;
      newWidth = width;
    }
	var newTopCorr = 2;
    $node
      .css('left', '')
      .css('right', '')
      .css('top', (top + height + newTopCorr) + 'px')
      .css(align, dist)
      .css('width', '' + newWidth + 'px');

    var suffix = 'lg';
    if (newWidth < 300) suffix = 'xs';
    else if (newWidth < 600) suffix = 'sm';
    else if (newWidth < 900) suffix = 'md';

    $dropdown
      .removeClass('aa-dropdown-menu-size-xs')
      .removeClass('aa-dropdown-menu-size-sm')
      .removeClass('aa-dropdown-menu-size-md')
      .removeClass('aa-dropdown-menu-size-lg')
      .addClass('aa-dropdown-menu-size-' + suffix);
  }

  autocomplete = algolia.autocomplete = {
    articles: {
      enabled: algolia.config.index_articles,
      hitsPerPage: algolia.config.articles_autocomplete_hits_per_page,
      index: index('articles'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_articles_empty'),
        hit: algolia.compileTemplate('autocomplete_article')
      }
    },
    pages: {
      enabled: algolia.config.index_pages,
      hitsPerPage: algolia.config.pages_autocomplete_hits_per_page,
      index: index('pages'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_pages_empty'),
        hit: algolia.compileTemplate('autocomplete_page')
      }
    },
    collections: {
      enabled: algolia.config.index_collections,
      hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
      index: index('collections'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_collections_empty'),
        hit: algolia.compileTemplate('autocomplete_collection')
      }
    },
    colors: algolia.config.colors,
    debug: algolia.config.autocomplete_debug,
    poweredBy: algolia.config.powered_by,
    products: {
      enabled: algolia.config.index_products,
      distinct: algolia.config.show_products,
      hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
      index: index('products'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_products_empty'),
        footer: algolia.compileTemplate('autocomplete_footer'),
        hit: algolia.compileTemplate('autocomplete_product')
      },
    },
    selector: algolia.config.input_selector + ', .algolia-shopify-autocomplete',
    showFooter: algolia.config.instant_search_enabled,
    storeName: algolia.storeName,
    templates: {
      dropdown: algolia.compileTemplate('autocomplete'),
      empty: '<div></div>',
      style: algolia.compileTemplate('autocomplete.css')
    }
  };

  if (autocomplete.poweredBy) {
    console.log('Algolia: Autocomplete');
  }

  algolia.appendStyle(algolia.render(autocomplete.templates.style, {
    colors: autocomplete.colors
  }));
  
  
// PREP DEV VERSION 2.1.10 //
function easy_autoComplete() {
  	var templates = {
    	empty: function displayEmptyResultSet (props) {
          return algolia.render(algolia.compileTemplate('autocomplete_products_empty'), Object.assign({}, props, { translations: algolia.translations }));
        },
        suggestion: function displaySuggestion (hit) {
          return algolia.render(algolia.compileTemplate('autocomplete_product'), Object.assign({}, hit, {translations: algolia.translations}));
        }
	};
	return {
		name: 'products',
		source: function(query, callback) {
        	var searchOpts = {
          		hitsPerPage: 24,
          		distinct: true,
          		clickAnalytics: true,
          		highlightPreTag: '<span class="aa-highlight">',
          		highlightPostTag: '</span>',
          		filters: algolia_AC_strip
        	};
        	index('products_title_asc').search(query, searchOpts).then(function(answer) {
          	var hits = addPositionToHits(answer.hits, answer.queryID, 'hemm_products_title_asc');
            $('.easyorder-searchcontainer .aa-dropdown-menu').scrollTop(0);
          	callback(hits, answer);
        });
      },
      displayKey: function(suggestion) {titleArr = suggestion.title.split('.'); return titleArr[0] },
      templates: templates
    }
}
// END PREP DEV VERSION 2.1.10 //  

	$(document).ready(
    
  	function mainAutocomplete () {
    	 // PREP DEV VERSION 2.1.10 //
        $('.easyorderSearchbox').autocomplete({ 
            hint: false,
            autoselect: true,
            debug: false,
        }, _.compact([
            easy_autoComplete()
        ])
        ).on('autocomplete:selected', function(event, suggestion, dataset, context){
            /* functions in easyorder_script  */
            easy_step2_colors();
        });
        // END PREP DEV VERSION 2.1.10 //
    
    
    autocomplete.$input = $(autocomplete.selector);
    autocomplete.$input.autocomplete({
      debug: autocomplete.debug,
      hint: false,
      appendTo: 'body',
      templates: {
        dropdownMenu: algolia.render(autocomplete.templates.dropdown, {
          storeName: autocomplete.storeName,
          with: {
            articles: autocomplete.articles.enabled,
            collections: autocomplete.collections.enabled,
            pages: autocomplete.pages.enabled,
            footer: autocomplete.showFooter,
            poweredBy: autocomplete.poweredBy,
            products: autocomplete.products.enabled
          }
        }),
        empty: autocomplete.templates.empty
      }
    }, _.compact([
      autocompleteSection('collections'),
      autocompleteSection('articles'),
      autocompleteSection('pages'),
      autocompleteSection('products')
    ]));

    // Hack to handle buggy onclick event on iOS
    autocomplete.$input.each(function () {
      var data = $(this).data('aaAutocomplete');
      var dropdown = data.dropdown;
      var suggestionClass = '.' + dropdown.cssClasses.prefix + '-' + dropdown.cssClasses.suggestion;
      var onSuggestionClick = dropdown._onSuggestionClick.bind(dropdown);

      var touchmoved;
      dropdown.$menu.on('touchend', suggestionClass, function (e) {
        if(touchmoved === false) {
          e.preventDefault();
          e.stopPropagation();
          onSuggestionClick.apply(this, arguments);
        }
      }).on('touchmove', function (){
        touchmoved = true;
      }).on('touchstart', function(){
        touchmoved = false;
      });
    });

    autocomplete.$input.on('autocomplete:selected', function (obj, datum, name) {
      if (name === 'products') {
        var addVariantId = !autocomplete.products.distinct && datum.objectID !== datum.id;
        //if(aaPushAuto){
        //  aaPushAuto(datum.handle, datum._indx_used, datum._queryID, datum.objectID, datum._position);
        //}
        window.location.href = main_globlang_pref + '/' + name + '/' + datum.handle;
      } else if (name === 'articles') {
        window.location.href = main_globlang_pref + '/blogs/' + datum.blog.handle + '/' + datum.handle;
      } else {
        window.location.href = main_globlang_pref + '/' + name + '/' + datum.handle;
      }
    })

    autocomplete.$input.on('autocomplete:redrawn', function () {
      readjust($(this));
    });

    $(window).resize(function () {
      autocomplete.$input.each(function () {
        readjust($(this));
      });
    });
  });
}(algoliaShopify));

/* #5. */
(function (algolia) {
  'use strict';

  var _ = algolia._;

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, params: {step:5} },
    menu: { name: 'menu', params: { limit: 100 } },
    conjunctive: { name: 'refinementList', params: { operator: 'and', limit: 100 } },
    disjunctive: { name: 'refinementList', params: { operator: 'or', limit: 100 } },
  };

  var sortByRefined = function sortByRefined (sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges (a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    })
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange (value) {
      var values = value.split(':');

      return _.map(values, function (e) {
        return algolia.formatMoney(+e * 100).replace(/\.\d+/, '');
      }).join(' - ');
    },
    'named_tags.Stretch': function displayYesOrNo(stretchval) {
      if(stretchval == '0'){
        return algolia.translations.no;
      } else if(stretchval == '1'){
        return algolia.translations.yes;
      }
    }
  }

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: 'ais-facet--count'
  };

  // NEW LANGUAGE SETUP //
  var persistFacets = ['composition','grams','certificates','stretch','swatch'];
  var configLng = algolia.language+'__';
  var configdataFacets = algolia.config.facets;
  var confignewFacets = [];
  _.each(configdataFacets, function (facet) {
    var fct_pref = algolia.language;
    var fct_name = facet.name;
    var fct_name_clean = fct_name.toLowerCase().replace('named_tags.','');
    if(persistFacets.indexOf(fct_name_clean) >= 0){
      	confignewFacets.push(facet);
    } else if(fct_name_clean.indexOf(configLng) >= 0){
      	confignewFacets.push(facet);
    }
  });
  var enabledFacets = _.filter(confignewFacets, function (facet) { return facet.enabled || parseInt(facet.enabled); });

  algolia.facets = _.map(enabledFacets, function (facet) {
    return Object.assign({}, facet, { escapedName: encodeURIComponent(facet.name) }) 
  });
  algolia.shownFacets = _.filter(algolia.facets, function (facet) { return facet.type !== 'hidden' });
  algolia.hiddenFacets = _.filter(algolia.config.facets, function (facet) { return facet.type === 'hidden'; });
  algolia.facetTitles = {};
  _.each(algolia.facets, function (facet) {
    if(facet.title == 'Weight' || facet.title == 'Composition' || facet.title == 'Certificates' || facet.title == 'Swatch'){
      var factrkey = facet.title.toLowerCase();
      facet.title = algolia.translations[factrkey];
    }
    algolia.facetTitles[facet.name] = facet.title;
  });
  
  
  algolia.facetsWidgets = _.map(algolia.shownFacets, function (facet) {

    var widget = TYPES_TO_WIDGET[facet.type],
        params = _.cloneDeep(widget.params) || {};

    params.container = "[class~='ais-facet-" + facet.escapedName + "']";
    params.attributeName = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    if (facet.searchable) {
      params.searchForFacetValues = {placeholder: 'Search for ' + facet.name, isAlwaysActive: true};
      params.searchForFacetValues.templates = {noResults: '<div> No matching ' + facet.name + '</div>'};
    }

    params.templates.header = function () {
      return facet.title;
    }

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('instant_search_facet_item');
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformData = function (data) {
      data.type = {};
      data.type[facet.type] = true;
      data.aisFacInd = facet.escapedName;
      if (displayFunction) {
        data.name = displayFunction(data.name);
      }
      return data;
    }
    
    return {
      name: widget.name,
      params: params
    };
  });
}(algoliaShopify));

/* #6. */
(function (algolia) {
  'use strict';
  var _ = algolia._;
  var sort_order_base = '' + algolia.config.index_prefix + 'products';
  algolia.sortOrders = [ { name: sort_order_base, label: '' + algolia.translations.sort_labels['default'] } ];
  
  //algolia.config.sort_orders = [
  // {key:"groupby", title: "Group By", desc: {active: true, title: "Art.Nr. (grouped)"}},
  //  ...
  //];

  _.forEach(algolia.config.sort_orders, function (sort_order) {
    if (!_.isUndefined(sort_order.asc) && !_.isNull(sort_order.asc) && (sort_order.asc.active === true || sort_order.asc.active === '1')) {
      algolia.sortOrders.push({ name: sort_order_base + '_' + sort_order.key + '_asc', label: algolia.translations.sort_labels[sort_order.key+'_asc'] });
    }
    if (!_.isUndefined(sort_order.desc) && !_.isNull(sort_order.desc) && (sort_order.desc.active === true || sort_order.desc.active === '1')) {
      
      algolia.sortOrders.push({ name: sort_order_base + '_' + sort_order.key + '_desc', label: algolia.translations.sort_labels[sort_order.key+'_desc'] });
    }
  });
}(algoliaShopify));

/* #7. */
(function (algolia, instantsearch) {
  var collectionFacetConstraint = !!algolia.is_collection_results_page &&
    !!algolia.config.instant_search_enabled_on_collection;
  if (
      (!algolia.full_results && !collectionFacetConstraint) || !algolia.config.instant_search_enabled
    ) {
    return;
  }

  var _ = algolia._,
      $ = algolia.jQuery;
  
  var algolia_IS_strip = ' NOT "product_type":"Sample" AND NOT "product_type":"Special" ';  
  if(!!cust_globspec_col && cust_globspec_col.length > 3){
    var algolia_IN_adj = cust_globspec_col;
    if(algolia_IN_adj.substring(0, 1) == 'c' ){
      algolia_IS_strip = ' ("named_tags.SpecialFor":"'+algolia_IN_adj+'" OR "product_type":"Fabric") ';
    }
  }
  
  // ADDING AVAIL FILTER //
  var algolia_Match_Avail = window.location.href;
  if(algolia_Match_Avail.indexOf('availf=roll') > -1){
    // rolls in stock //
    algolia_IS_strip += ' AND ("variant_title":"Rolls" AND "meta.availability.Availability":"1000")';
  } else if(algolia_Match_Avail.indexOf('availf=fold') > -1){
    // double folded in stock
    algolia_IS_strip += ' AND ("variant_title":"Double Folded" AND "meta.availability.Availability":"1000")';
  }

  var collectionFacetValue = null;
  if (collectionFacetConstraint) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    if (!!matches && matches.length === 2) {
      collectionFacetValue = matches[1];
    }
  } 

  algolia.config.results_selector += ', .algolia-shopify-instantsearch';

  var $hiding = $('<style>' + algolia.config.results_selector + ' { visibility: hidden }</style>');
  $hiding.appendTo($('head'));

  var instant = algolia.instantsearch = {
    colors: algolia.config.colors,
    distinct: !!algolia.config.show_products,
    facets: {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets
    },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + 'products',
      searchParameters: {
        clickAnalytics: true,
        facetingAfterDistinct: true
      },
      urlSync: {},
      searchFunction: function (searchFunctionHelper) {
        var helper = instant.search.helper;
        var page = helper.getPage();
        if(page > 100){ // page137fix
          page = 0;
        }
        /* NEW INTENTION CORRECTION */
        var aisQbox = $('input.aa-input').val();
        var aisReQuery = intentionCorrection(aisQbox);
        helper.setQueryParameter('query', aisReQuery);
        
        helper.setQueryParameter('highlightPreTag', '<span class="ais-highlight">');
        helper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          helper.setQueryParameter('distinct', true);
        }
        if (!!collectionFacetConstraint && !!collectionFacetValue) {
          helper.setQueryParameter('filters', '"collections":"' + collectionFacetValue + '" AND ' + algolia_IS_strip);
        } else {
          helper.setQueryParameter('filters', algolia_IS_strip); 
        }
        if(typeof cust_glob_did == 'string' && typeof main_globlang == 'string'){
          if(cust_glob_did == ''){
              helper.setQueryParameter('userToken', main_globlang);
              helper.setQueryParameter('enableABTest', false);
          } else {
              helper.setQueryParameter('userToken', cust_glob_did);
              helper.setQueryParameter('enableABTest', true);  
              helper.setQueryParameter('getRankingInfo', true);
          }       
        }
        //console.log(helper);
        helper.setPage(page);
        searchFunctionHelper.search();
      }
    }),
    selector: algolia.config.results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: algolia.sortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css')
    }
  };

  if (instant.poweredBy) {
    // console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.outerWidth();

    var suffix = 'lg';
    if (width < 550) suffix = 'xs';
    else if (width < 1000) suffix = 'sm';
    else if (width < 1300) suffix = 'md';

    instant.$results
      .removeClass('ais-results-size-xs')
      .removeClass('ais-results-size-sm')
      .removeClass('ais-results-size-md')
      .removeClass('ais-results-size-lg')
      .addClass('ais-results-size-' + suffix);
  }

  // Bind helpers
  _.forEach(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (helper, name) {
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(algolia.render(instant.templates.style, {
    distinct: instant.distinct,
    colors: instant.colors
  }));

  $(document).ready(function () {

    if ($(algoliaShopify.config.results_selector).length == 0) {
      throw new Error('Instant search CSS selector is incorrect\nFore more info see : https://community.algolia.com/shopify/css_selector.html#algolia-search');
    }

    instant.$results = $(instant.selector);
    instant.$results.html(algolia.render(instant.templates.page, {
      facets: instant.facets.list,
      storeName: instant.storeName,
      translations: algolia.translations
    }));

    readjust();

    $(window).resize(function () {
      readjust();
    });

    // Mobile facets display
    instant.search.addWidget({
      init: function (opts) {
        var $button = $('.ais-facets-button');
        $button.on('click', function () {
          var $facets = $('.ais-facets');
          if ($facets.hasClass('ais-facets__shown')) {
            $button.text(algolia.translations.showFilter);
            $facets.removeClass('ais-facets__shown');
            $('body').removeClass('ais-mobfacets__open');
          } else {
            $button.text(algolia.translations.hideFilter);
            $facets.addClass('ais-facets__shown');
            $('body').addClass('ais-mobfacets__open');
          }
        });
      }
    });

    // Search input
    instant.search.addWidget(
      instantsearch.widgets.searchBox({
        container: '.ais-search-box-container',
        placeholder: algolia.translations.searchForProduct,
        poweredBy: false
      })
    );

    // Logo & clear
    instant.search.addWidget({
      init: function (opts) {
        if (!instant.poweredBy) {
          $('.ais-algolia-icon').hide();
        }
        $('.ais-clear-input-icon').on('click', function () {
          opts.helper.setQuery('').search();
          $('.ais-search-box--input').val('').focus();
        });
      },
      render: function (opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            $('.ais-algolia-icon').show();
          }
          $('.ais-clear-input-icon').hide();
        } else {
          $('.ais-clear-input-icon').show();
          $('.ais-algolia-icon').hide();
        }
      }
    });

    // Stats
    instant.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-stats-container',
        templates: {
          body: instant.templates.stats,
        },
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1000;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          }
        }
      })
    );

    // Stats copy
    instant.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-stats-container-copy',
        templates: {
          body: instant.templates.stats,
        },
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1000;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          }
        }
      })
    );

    // Sort orders
    instant.search.addWidget(
      instantsearch.widgets.sortBySelector({
        container: '.ais-sort-orders-container',
        indices: instant.sortOrders
      })
    );

    // Change display
    instant.search.addWidget({
      init: function (opts) {
        $('.ais-search-header').on('click', '.ais-change-display-block', function () {
          $('.ais-change-display-block:not(.ais-change-display-selected)').addClass('ais-change-display-selected');
          $('.ais-change-display-list.ais-change-display-selected').removeClass('ais-change-display-selected');
          $('.ais-results-as-list').removeClass('ais-results-as-list').addClass('ais-results-as-block');
        });
        $('.ais-search-header').on('click', '.ais-change-display-list', function () {
          $('.ais-change-display-list:not(.ais-change-display-selected)').addClass('ais-change-display-selected');
          $('.ais-change-display-block.ais-change-display-selected').removeClass('ais-change-display-selected');
          $('.ais-results-as-block').removeClass('ais-results-as-block').addClass('ais-results-as-list');
        });
      }
    });

    // Hidden facets
    var list = _.map(instant.facets.hidden, function (facet) { return facet.name; });
    instant.search.addWidget({
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list
        };
      },
      init: function () {}
    });

    // Current refined values
    var attributes = _.map(instant.facets.shown, function(facet) {
      var displayFunction = algolia.facetDisplayFunctions[facet.name];
      return {
        name: facet.name,
        label: facet.title,
        transformData: function (value) {
          value.aisFacInd = facet.escapedName;
          if (displayFunction) {
            value.name = displayFunction(value.name);
          }
          return value;
        }
      }
    });
    instant.search.addWidget(
      instantsearch.widgets.currentRefinedValues({
        container: '.ais-current-refined-values-container',
        cssClasses: {
          root: 'ais-facet',
          header: 'ais-facet--header',
          body: 'ais-facet--body'
        },
        templates: {
          header: algolia.translations.selectedFilter,
          item: instant.templates.currentItem,
          clearAll: algolia.translations.clearAll
        },
        onlyListedAttributes: true,
        attributes: attributes
      })
    );

    // Facets
    _.forEach(instant.facets.widgets, function (widget) {
      instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
    });

    // Hits
    instant.search.addWidget(
      instantsearch.widgets.hits({
        container: '.ais-hits-container',
        hitsPerPage: instant.hitsPerPage,
        templates: {
          empty: instant.templates.empty,
          item: instant.templates.product
        },
        transformData: {
          item: function (product) {
            product._distinct = instant.distinct;
            product._indx_used = instant.search.helper.lastResults._rawResults[0].index;
            product.can_order = (
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0
            );
            product.translations = algolia.translations;
            product.queryID = instant.search.helper.lastResults._rawResults[0].queryID;
            product.productPosition = product.__hitIndex + 1;
            return product;
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          }
        }
      })
    );

    // evHub on result container //
    instant.search.addWidget({
      render: function (opts) {
        if(instant.search.helper.lastResults._rawResults[0] && instant.search.helper.lastResults._rawResults[0].index){
            var currEVindx = instant.search.helper.lastResults._rawResults[0].index;
            var currEVqry = instant.search.helper.lastResults._rawResults[0].queryID;
            $('.algolia-shopify-instantsearch').attr('data-evhub-index', currEVindx);
            $('.algolia-shopify-instantsearch').attr('data-evhub-queryid', currEVqry);
            // add temp ab info //
            if($('.footer-endline-col.endline-col-1 p em').length == 0){
              if(instant.search.helper.lastResults._rawResults[0].abTestID && instant.search.helper.lastResults._rawResults[0].abTestVariantID){
                var currABinfo = instant.search.helper.lastResults._rawResults[0].abTestID + '#' + instant.search.helper.lastResults._rawResults[0].abTestVariantID;
                var currABelem = '<em title="'+currABinfo+'">.</em>';
                $('.footer-endline-col.endline-col-1 p').append(currABelem);
              }
            }
        }
      }
    });

    // No result actions
    instant.search.addWidget({
      init: function (opts) {
        $('.ais-hits-container').on('click', '.ais-hit-empty--clear-filters', function () {
          var helper = opts.helper;
          helper.clearTags();
          _.forEach(instant.facets.list, function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });
        $('.ais-hits-container').on('click', '.ais-hit-empty--clear-input', function () {
          opts.helper.setQuery('').search();
          $('.ais-search-box--input').val('').focus();
        });
      }
    });

    // Pagination
    instant.search.addWidget(
      instantsearch.widgets.pagination({
        container: '.ais-pagination-container',
        padding: 4,
        maxPages: 100,
        scrollTo: document.querySelector('.aisScrollTo')
      })
    );

    // Main
    instant.search.start();
    $hiding.remove();
  });
}(algoliaShopify, instantsearch));